var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('button',{staticClass:"tla-btn tla-btn--primary tla-btn--block",class:{ 'tla-btn--spaced-bottom': _vm.isLast },attrs:{"name":"scroll-to-button","id":"scroll-to-button"},on:{"click":function($event){return _vm.scrollToForm()}}},[_vm._v(" "+_vm._s(_vm.buttonText)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }